export const BASE_URL = import.meta.env['VITE_API_URL']

export const IS_PRODUCTION =
  import.meta.env['VITE_PRODUCTION'] == 'true' ? true : false
